import Auth, { CognitoUser } from '@aws-amplify/auth';
import { Hub } from 'aws-amplify';
import { createContext, FC } from 'react';
import { useAuth } from './hooks';
import { SignInInput } from './types';

export interface AuthState {
  user: CognitoUser | undefined;
  signIn(input: SignInInput): Promise<void>;
  signOut(): Promise<void>;
  deleteUser(): Promise<void>;
}

export const AuthContext = createContext<AuthState>({
  user: undefined,
  signIn: async (_: SignInInput) => {},
  signOut: async () => {},
  deleteUser: async () => {},
});

export const AuthProvider: FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const AmplifyAuth = Auth;
export const AmplifyHub = Hub;
